import { getAmplitudeInstance } from '../amplitudeHelpers';
import CommunityProfileLocation from '../enums/CommunityProfileLocation';

type logCommunityProfileClickedParams = {
  carousel_position: number;
  extra_reasons?: string[];
  item_position?: number;
  primary_reason_label?: string;
  primary_reason_score?: number;
  primary_reason_type?: string;
  profile_location: CommunityProfileLocation;
  profile_user_id: number;
};

/**
 * A user profile is clicked on. Excludes when a user clicks on the poster profile of a Community feed post (see CommunityFeedPostClicked for those events).
 * @param params - Attributes to log with the amplitude event
 * @param params.carousel_position - The 0-indexed position of the carousel in the user's feed, if the interaction occurred on a carousel
 * @param params.extra_reasons - (Suggested members) List of JSON strings with metadata containing other reasons for the recommendation
 * @param params.item_position - The 0-indexed position of the user_id in the relevant location
 * @param params.primary_reason_label - (Suggested members) Free-text message explaining why the user is recommended.
 * @param params.primary_reason_score - (Suggested members) Recommendation score for the primary reason
 * @param params.primary_reason_type - (Suggested members and contacts) The reason the user is recommended or shown
 * @param params.profile_location - The location where the profile was clicked.
 * @param params.profile_user_id - The user_id of the profile clicked
 */
const logCommunityProfileClicked = (
  {
    carousel_position,
    extra_reasons,
    item_position,
    primary_reason_label,
    primary_reason_score,
    primary_reason_type,
    profile_location,
    profile_user_id
  }: logCommunityProfileClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'community profile clicked',
    {
      'carousel position': carousel_position,
      'extra reasons': extra_reasons,
      'item position': item_position,
      'primary reason label': primary_reason_label,
      'primary reason score': primary_reason_score,
      'primary reason type': primary_reason_type,
      'profile location': profile_location,
      'profile user id': profile_user_id
    },
    callback
  );
};

export default logCommunityProfileClicked;
